import React from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
import { Facebook } from 'lucide-react';
export function CommunitySection() {
  return <section className="py-20 bg-gray-100" data-id="element-25">
      <Container data-id="element-26">
        <div className="bg-white rounded-lg shadow-xl overflow-hidden flex flex-col md:flex-row" data-id="element-27">
          {/* Content */}
          <div className="p-8 md:p-12 flex-1 flex flex-col justify-center" data-id="element-28">
            <div className="flex items-center gap-3 mb-6" data-id="element-29">
              <div className="bg-[#1877F2] p-2 rounded-full text-white" data-id="element-30">
                <Facebook size={24} data-id="element-31" />
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-nav font-heading uppercase" data-id="element-32">
                Connect With Us on Facebook
              </h2>
            </div>

            <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-33">
              Like Us on Facebook! Simply click the Facebook Page Posts to the
              left! You can even post from here and send a message to Master
              Sergio!
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-34">
              <a href="https://www.facebook.com/DragonMartialArtsofRoundLake" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-35">
                <Button variant="primary" className="bg-[#1877F2] hover:bg-[#166fe5] w-full flex items-center justify-center gap-2" data-id="element-36">
                  <Facebook size={18} data-id="element-37" />
                  Visit Our Facebook
                </Button>
              </a>
              <a href="#signup" className="w-full sm:w-auto" data-id="element-38">
                <Button variant="default" className="w-full" data-id="element-39">
                  Get One Week Free Trial
                </Button>
              </a>
            </div>
          </div>

          {/* Image */}
          <div className="md:w-1/2 lg:w-2/5 relative min-h-[300px]" data-id="element-40">
            <img src="https://cdn.magicpatterns.com/uploads/77h8yk8uHWN84WPPPzCuss/Connect-With-Dragon-Martial-Arts-Taekwondo-School.jpg" alt="Dragon Martial Arts Taekwondo instructors" className="absolute inset-0 w-full h-full object-cover" data-id="element-41" />
            <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent md:bg-gradient-to-l md:from-transparent md:to-white/10" data-id="element-42"></div>
          </div>
        </div>
      </Container>
    </section>;
}